module.exports = __webpack_public_path__ + "img/child_box.241540f1.png";